import React, { Component, Fragment } from 'react';

import Stop from 'Models/Stop';
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown';
import Checkbox from 'Components/Checkbox';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import PlacesAutoComplete from 'Components/PlacesAutoComplete';
import { getUser } from 'Utils/storage';
import ClickOutside from 'Components/ClickOutside';
import Autosuggest from 'react-autosuggest';
import { isAdaniWilmar } from 'Utils/';
import { CENTURY_PLY, EMAMI, GREEN_PLY, AVG_DISTANCE, STAR_CEMENT, CARGIL, BEAM, DEEPAK_PHENOLICS_SAP, MUNDRA_SOLAR } from 'Constants/commonConstants';
import {withRouter} from 'react-router-dom'
import { isCoromandel, isDesmet } from 'Utils/index';
import { validatePincodeWithPostalApi } from 'Utils/api';
import ActionLoader from 'Components/ActionLoader';

const PINCODE_REGEX = /^\d{6}$/;

const getNetworkSuggestionValue = suggestion => ( isDesmet() ? suggestion.company_name : suggestion.branch_name );
const renderNetworkSuggestion = suggestion => <span>{ isDesmet() ? suggestion.company_name : suggestion.branch_name }</span>;

class StopDetails extends Component {
	constructor(props) {
		super(props);
		this.trip = props.trip;
		this.viewMode = props.viewMode;
		this.stops = this.trip.stops;
		this.state = {
			stops: this.trip.stops,
			fromLoc: null,
			toLoc: null,
			searchFromText: '',
			searchToText: '',
			consignees: this.trip.consignees,
			consigners: this.trip.consigners,
			routeCode: '',
			fromRange: this.trip.fromRange || '',
			toRange: this.trip.toRange || '',
			location: this.trip.location || '',
			transportation_zone: this.trip.transportZone || '',
			pincodeErrors: {},
			pincodeLoading: {}
		}
	}
	addStop = () => {
		if (this.viewMode) {
			return;
		}
		this.props.trip.addStop();
		this.setState({
			stops: this.trip.stops
		});
	}
	setLocation = (index, location, routeCodeParam) => {
		const {rfq ,match} = this.props;
		if (this.viewMode) {
			return;
		}
		// const { isRoundTrip } = this.state;
		this.state.stops[index].setLocation(location);
		if (this.state.pincodeErrors[index]) {
			this.setPincodeError(index, undefined);
		}
		// if(isRoundTrip && index === 0) {
		//this.state.stops[index + 1].setLocation(location);
		// }
		const fromLocation = this.state.stops[0].location;
		const toLocation = (this.state.stops[1] || {}).location;
		if (!CENTURY_PLY.includes(getUser().companyId) && fromLocation && toLocation) {
			const from = fromLocation.split(',')[0];
			const to = toLocation.split(',')[0];
			if(!([...BEAM, ...DEEPAK_PHENOLICS_SAP].includes(getUser().companyId))) {
				this.props.getRouteCode(from, to, match.params.type, isCoromandel() ? routeCodeParam : undefined);
			}
			if(isAdaniWilmar()) {
				this.props.getTripExistConfirmationPopup(from, to, this.clearStopDetails)
			}
		} else if (!CENTURY_PLY.includes(getUser().companyId) && (!fromLocation || !toLocation)) {
			// Clear route code fields when either from or to location is removed
			this.trip.routeCode = '';
			this.trip.transportZone = '';
			this.trip.location = '';
			this.trip.addRouteCode('');
			this.trip.addTransportZone('');
			this.trip.addLocation('');
			this.setState({ routeCode: '', transportation_zone: '', location: '' });
		}
		if(isDesmet() && [0,1,'0', '1'].includes(index) && (this.state.stops[index] || {}).location){
			this.props.getNetWorkData((this.state.stops[index] || {}).location.split(',')[0], index + 1);
		}
		this.props.onChange();
	}

	clearStopDetails = () => {
		this.state.stops[0].setLocation({ pincode: '' });
		this.state.stops[1].setLocation({ pincode: '' });
		this.props.onChange();
	}

	changeLandmark = (index, e) => {
		if (this.viewMode) {
			return;
		}
		// const { isRoundTrip } = this.state;
		const stops = [...this.state.stops];
		stops[index].landmark = e.target.value;
		// if( isRoundTrip && index === 0) {
		// stops[index + 1].landmark = e.target.value;
		// }
		this.setState({
			stops
		})
		this.stops[index].setLandmark(e.target.value);
	}
	changeRemarks = (index, e) => {
		if (this.viewMode) {
			return;
		}
		const stops = [...this.state.stops];
		stops[index].remarks = e.target.value;
		this.setState({
			stops
		});
		this.stops[index].setRemarks(e.target.value);
	}
	OnChangeSo = (e) => {
		if (this.viewMode) {
			return;
		}
		this.trip.setSo(e.target.value);
		this.setState({});
	}
	OnChangePdc = (e) => {
		if (this.viewMode) {
			return;
		}
		this.trip.setPdc(e.target.value);
		this.setState({});
	}
	changeStopType = (index, type) => {
		if (this.viewMode) {
			return;
		}
		const stops = [...this.state.stops];
		stops[index].type = type;
		this.setState({
			stops
		})
		this.stops[index].setType(type);
	}
	setPincodeError = (index, message) => {
		this.setState({
			pincodeErrors: {
				...this.state.pincodeErrors,
				[index]: message
			}
		}, () => {
			if (this.props.onPincodeErrorChange) {
				this.props.onPincodeErrorChange(Object.values(this.state.pincodeErrors).some(Boolean));
			}
		});
	}
	changePincode = (index, e) => {
		if (this.viewMode) {
			return;
		}
		const value = e.target.value.replace(/\D/g, '').slice(0, 6);
		const stops = [...this.state.stops];
		stops[index].pincode = value;
		this.setState({
			stops
		});
		this.stops[index].setPincode(value);
		this.setPincodeError(index, undefined);
	}
	getPincodeError = (index, pincode, requiredMessage) => {
		const apiError = this.state.pincodeErrors[index];
		if (apiError) {
			return apiError;
		}
		if (this.props.submitted) {
			if (!pincode) {
				return requiredMessage;
			}
			if (!PINCODE_REGEX.test(pincode)) {
				return 'Please Enter a Valid 6-Digit PIN Code';
			}
		}
		return null;
	}
	validatePincode = (index) => {
		if (this.viewMode) {
			return;
		}
		const { rfq } = this.props;
		const { validate_pincode_on_upload } = rfq.rfqDetails || {};
		const pincode = (this.state.stops[index] || {}).pincode || '';
		if (!pincode) {
			return;
		}
		if (!PINCODE_REGEX.test(pincode)) {
			this.setPincodeError(index, 'Please Enter a Valid 6-Digit PIN Code');
			return;
		}
		if (!validate_pincode_on_upload) {
			return;
		}
		this.setState({
			pincodeLoading: {
				...this.state.pincodeLoading,
				[index]: true
			}
		});
		validatePincodeWithPostalApi(pincode).then((isValid) => {
			this.setPincodeError(index, isValid ? undefined : 'Please Enter a Valid PIN Code');
		}).catch(() => {}).finally(() => {
			this.setState({
				pincodeLoading: {
					...this.state.pincodeLoading,
					[index]: false
				}
			});
		});
	}
	changeAdditionalPrice = (index, e) => {
		if (this.viewMode) {
			return;
		}
		const stops = [...this.state.stops];
		stops[index].additionalPrice = e.target.value;
		this.setState({
			stops
		});
		this.stops[index].setAdditionalPrice(e.target.value);
	}
	removeStop = (index) => {
		if (this.viewMode) {
			return;
		}
		this.trip.removeStop(index);
		this.setState({
			stops: this.trip.stops
		});
		this.props.onChange();
	}
	onChange = (e, index) => {
		const dropdownType = `show${e.target.name}Autosuggest`;
		const user = getUser();
		this.setState({
			[e.target.name]: e.target.value,
			[dropdownType]: true,
		})
		if(user && user.showPinCodeDetails && e.target.value.length > 5) {
			this.props.getPinCode(e.target.value, index !== 0)
		}
		let data = e.target.value;
		if([...EMAMI, ...STAR_CEMENT].includes(user.companyId)) {
			// const stopDetails = ((e.target.value || '').split(',') || []);
			data = {
				location: e.target.value,
				city: e.target.value,
			}
		}
		if(CENTURY_PLY.includes(user.companyId)) {
			const { value } = e.target;
			const from = (index === 0 ? value : ((this.stops[0] || {}).location || '').split(',')[0]);
			const to = index === 1 ? value : undefined;
			this.props.getSAPRouteCodes(null, from , to);
		}
		if([...BEAM, ...DEEPAK_PHENOLICS_SAP].includes(user.companyId)) {
			const { value } = e.target;
			let from=""
			let to=""
			let from_district = ""
			let from_state = ""
			let to_district = ""
			let to_state = ""
			if(isAdaniWilmar()){
			 from = (index === 0 ? value : ((this.stops[0] || {}).location || '').split(',')[0]);
			 from_district = (this.stops[0] || []).district||'';
			 from_state = (this.stops[0] || []).state||'';
			 

			 to = (index === 1 ? value : ((this.stops[1] || {}).location || '').split(',')[0]);
			 to_district = (this.stops[1] || []).district||'';
			 to_state = (this.stops[1] || []).state||''
			}
			else{
				 from = (index === 0 ? value : ((this.stops[0] || {}).location || '').split(',')[0]);
			      to = index === 1 ? value : undefined;
		    }
			this.props.getMasterRouteCodeDetails( from, to );
		}
		this.setLocation(index, data);
	}
	onSelect = (type, item, index) => {
		const isCPLY = CENTURY_PLY.includes(getUser().companyId);
		const beam = BEAM.includes(getUser().companyId);
		const dpl = DEEPAK_PHENOLICS_SAP.includes(getUser().companyId);
		
		const name = (item.state || item.source_state || item.destination_state) ? (getUser().showPinCodeDetails && item.location ? `${item.location}, ${item.pincode}` : `${item.city || ((beam || dpl) ? item[index === 0 ? 'source' : 'destination'] : '')}${(index === 0 ? item.source_district : item.destination_district) ? `, ${index === 0 ? item.source_district : item.destination_district}` : ''}, ${item.state ||  ((dpl || beam) ? (item[index === 0 ? 'source_state' : 'destination_state']) : (item.source_state || item.destination_state || ''))}${item.pincode ? `, ${item.pincode}` : ''}${item.country ? `, ${item.country}` : ''}` ) : ((isCPLY) ? (index === 0 ? `${item.source}` : `${item.destination}`) : `${item.city}`);
		const dropdownType = `show${type}Autosuggest`;
		this.setState({
			[type]: name ? name : this.state[type],
			[dropdownType]: false
		})
		// if(getUser().showPinCodeDetails && !item.location) {
		// 	item.location = item.location;
		// }
		if(isCPLY || beam || dpl) {
			item.location = item[index === 0 ? 'source' : 'destination'];
			item.city = item[index === 0 ? 'source' : 'destination'];
			if(beam || dpl) {
				item.location = index === 0 ? `${item.source},${item.source_district}, ${item.source_state}` : `${item.destination}, ${item.destination_district}, ${item.destination_state}`
				item.state = item[index === 0 ? 'source_state' : 'destination_state'];
			}
			if(index === 1 ? (this.stops[0] || {}).location : (this.stops[1] || {}).location) {
				this.trip.routeCode = item.sap_code;
				this.trip.distance = item.distance;
				this.trip.distance_uom = item.distance_uom;
				this.trip.addRouteCode(item.sap_code);
				if(item.distance) {
					let tat = (parseFloat(item.distance.replace(/[\s,]+/g, '')) / AVG_DISTANCE)
					if (item.distance < 250) {
						tat = 1
					}
					this.trip.biddingDetails.setTatValue(Math.round(tat));
                	this.trip.biddingDetails.setTatUnit({ name:"Days", value:1 });
				}
			}
		}
		this.setLocation(index, item);
	}
	onhideAutosuggest = (type) => {
		this.setState({ [type]: false });
	}

	onSelectNetworkSuggestion = (data) => {
		if(!isDesmet()) {
			this.props.getNetWorkData(data.value);
		}
		if(isDesmet() && this.props.consignorDetails.length === 0 && (this.state.stops[0] || {}).location){
			this.props.getNetWorkData((this.state.stops[0] || {}).location.split(',')[0], 1);
		}
	}

	onConsignorSuggestionsFetchRequested = (data) => {
		if (isDesmet()) {
			this.props.getNetWorkData('', 1, data.value);
		} else {
			this.onSelectNetworkSuggestion(data);
		}
	}

	onConsigneeSuggestionsFetchRequested = (data) => {
		if (isDesmet()) {
			this.props.getNetWorkData('', 2, data.value);
		} else {
			this.onSelectNetworkSuggestion(data);
		}
	}

	UNSAFE_componentWillReceiveProps = (nextProp) => {
		if (!CENTURY_PLY.includes(getUser().companyId) && (nextProp.trip.routeCode !== this.state.routeCode)) {
			this.setState({ routeCode: nextProp.trip.routeCode });
		}
	}

	getClusterDetails = () => {
		const { clusterDetails } = this.props;
		return (
			<>
				<div className="fSemibold fs-18 header-medium-color mb-5 pr">Cluster Code <sup className="danger-color ml-2 pr t-4">*</sup></div>
				<Dropdown
					items={clusterDetails || []}
					selectedItem={this.trip.clusterCode && (clusterDetails || []).find(cluster=>{return cluster.cluster_code === this.trip.clusterCode})} 
					displayKey="cluster_code" 
					name="clusterCode" 
					label="Select Cluster" 
					className="mb-20"
					searchEnabled={true}
					onSelect={(item) => {
						this.setLocation(0, {
							location: item.from,
							city: item.from,
							state: item.from_state
						});
						this.setLocation(1, {
							location: (item.to || []).join(', '),
							city: (item.to || []).join(', '),
							state: item.to_state
						});
						this.trip.clusterCode = item.cluster_code;
						this.trip.setClusterCode(item.cluster_code);
						this.props.onChange();
					}}
				/>
			</>
		)
	}

	getRouteCodeElement = () => {
		const { submitted, autoSuggestLocations } = this.props;
		const { routeCode, showRouteCode } = this.state;
		const isCPLY = CENTURY_PLY.includes(getUser().companyId);
		return (
		<>
		<Fragment>
			<div className="fSemibold fs-18 header-medium-color mb-5 pr">Route Code <sup className="danger-color ml-2 pr t-4">*</sup></div>
			<div className={'flex space-between'}>
				{(this.trip.routeCode || isCPLY || isCoromandel()) ?
					isCoromandel() ?
						<Input placeholder="Enter Route Code"
							className="mb-10"
							value={this.trip.routeCode || routeCode}
							onChange={(e) => {
								this.props.getSAPRouteCodes(e.target.value);
								this.trip.routeCode = e.target.value;
								this.trip.addRouteCode(e.target.value);
								this.setState({ routeCode: e.target.value, showRouteCode: true });
							}} />
					:
					<Input placeholder="Enter Route Code"
						className={isCPLY ? "mb-10" : "mb-30"}
						value={this.trip.routeCode || routeCode}
						readOnly={isCPLY ? false : true}
						onChange={(e) => {
							if(isCPLY) {
								this.props.getSAPRouteCodes(e.target.value)
							}
							this.setState({ routeCode: e.target.value, showRouteCode: true });
						}} /> :
					<Fragment>
						<Input placeholder="Enter Route Code" className={"mb-30"} value={routeCode} readOnly={true}
						// onChange={(e) => {
						// 	this.setState({ routeCode: e.target.value.trim() });
						// }}
							/>
						{/* {routeCode && <button className="ht-30 br-20 white-color bg-theme fs-16 fBold pl-20 pr-20 ml-10 mt-10" onClick={() => saveRouteCode(this.state.routeCode)}>Save</button>} */}
					</Fragment>}
					{
						isCPLY && showRouteCode &&
						<ClickOutside handleClickOutside={() => this.onhideAutosuggest(`showRouteCode`)}>
						<div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1 mt-40">
							{
								routeCode && routeCode.length > 0 && (autoSuggestLocations || []).filter((item) => {
									if (!routeCode) {
										return true;
									}
									return (item['sap_code'].toLowerCase().includes(routeCode.toLowerCase()));
								}).map((item, searchIndex) => {
									return (
										<div
											key={searchIndex}
											name={item.sap_code}
											className={"flex flex-middle pl-16 min-ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
											onClick={() => this.onSelectRouteCode(item)}
										>
											<>{`${item.sap_code}`}</>
										</div>
									)
								})
							}
						</div>
					</ClickOutside>
					}
					{
						isCoromandel() && showRouteCode &&
						<ClickOutside handleClickOutside={() => this.onhideAutosuggest(`showRouteCode`)}>
						<div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1 mt-40">
							{
								routeCode && routeCode.length > 0 && (autoSuggestLocations || []).filter((item) => {
									return (item['sap_code'] || '').toLowerCase().includes(routeCode.toLowerCase());
								}).map((item, searchIndex) => {
									return (
										<div
											key={searchIndex}
											className={"flex flex-middle pl-16 min-ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
											onClick={() => this.onSelectCoromandelRouteCode(item)}
										>
											{`${item.sap_code}${item.source ? ` - ${item.source}` : ''}${item.destination ? ` to ${item.destination}` : ''}`}
										</div>
									)
								})
							}
						</div>
						</ClickOutside>
					}
			</div>
			{submitted && !this.trip.routeCode && <div className={'error-color fs-14 fSemibold op-7 ml-5'}>{'Route Code is Missing'}</div>}
		</Fragment>
				{isCoromandel() && <div className="flex justify-between gap-24">
					<div className="flex flex-column w-50">
						<div className="fSemibold fs-18 header-medium-color mb-5">
							Transport Zone
							<sup className="danger-color ml-2">*</sup>
						</div>
						<Input
							value={this.trip.transportZone}
							readOnly
						/>
					</div>
					<div className="flex flex-column w-50">
						<div className="fSemibold fs-18 header-medium-color mb-5">
							Location
							<sup className="danger-color ml-2">*</sup>
						</div>
						<Input
							value={this.trip.location}
							readOnly
						/>
					</div>
				</div>}
	   </>
	)
	}

	onSelectRouteCode = (item) => {
		this.setLocation(0, {
			location: item.source,
			city: item.source
		});
		this.setLocation(1, {
			location: item.destination,
			city: item.destination
		});
		this.trip.routeCode = item.sap_code;
		this.trip.distance = item.distance;
		this.trip.distance_uom = item.distance_uom;
		this.trip.addRouteCode(item.sap_code);
		if(item.distance) {
			let  tat = parseFloat(item.distance.replace(/[\s,]+/g,'')) / AVG_DISTANCE
			if(item.distance < 250){
                 tat = 1
			}
			this.trip.biddingDetails.setTatValue(Math.round(tat));
			this.trip.biddingDetails.setTatUnit({ name:"Days", value:1 });
		}
		this.setState({
			showRouteCode: false
		})
	}

	onSelectCoromandelRouteCode = (item) => {
		this.setState({
			'searchFromText-0': item.source || '',
			'searchToText-1': item.destination || '',
			showRouteCode: false,
			transportation_zone: item.transportation_zone || '',
			location: item.location || ''
		});
		this.setLocation(0, {
			location: item.source,
			city: item.source
		}, item.sap_code);
		this.setLocation(1, {
			location: item.destination,
			city: item.destination
		}, item.sap_code);
		this.trip.routeCode = item.sap_code;
		this.trip.addRouteCode(item.sap_code);
		this.trip.transportZone = item.transportation_zone || '';
		this.trip.location = item.location || '';
		this.trip.addTransportZone(item.transportation_zone || '');
		this.trip.addLocation(item.location || '');
	}

	setFromToRange = (key, e) => {
		this.trip.setFromToRange(key, e.target.value);
		this.setState({
			[key]: e.target.value
		});
	}

	changeDropPoints = (key, e) => {
		this.trip.setNoOfDropPoints(e.target.value);
		this.setState({
			[key]: e.target.value
		});
	}

	getNetWorkDataDetails = (data = [], value) => {
		let fData = data || [];
		if(isDesmet() && value) {
			fData = (data || []).filter(el => ((el.company_name || '').toLowerCase()).includes(value && value.toLowerCase()));
		}
		return fData;
	}

	getOptionList = (index) => {
		let options = [];
		if(MUNDRA_SOLAR.includes(getUser().companyId) && index === 0) {
			options = ['Adani Technopark LTD. {MSPVL}, Mundra, Gujarat, India', 'Rasapir Circle, Dhrab, Mundra, Gujarat, India'];
		}
		return options;
	}

	render() {
		const { stops, searchFromText, searchToText, fromLoc, consignees, consigners, routeCode, fromRange, toRange, pincodeLoading } = this.state;
		const { submitted, autoSuggestLocations, rfqServiceType, networkData, saveRouteCode, rfq, zoneWiseDetails, ftlContractTypeList, masterRouteCodeDetails, consignorDetails } = this.props;
		const user = getUser();
		const isEmami = [...EMAMI, ...STAR_CEMENT].includes(user.companyId);
		const isCPLY = CENTURY_PLY.includes(user.companyId);
		const beam = BEAM.includes(user.companyId);
		const dpl = DEEPAK_PHENOLICS_SAP.includes(user.companyId);
		const isMundraSolar = MUNDRA_SOLAR.includes(user.companyId);
		const showCustomLocationInput = ((user && user.isChallengePriceForm && user.companyId !== 'f13b2e9106724bca8e3e99f5c8751aa4') || user.showPinCodeDetails || GREEN_PLY.includes(user.companyId) || isEmami || isCPLY || beam || dpl);

		const { ftlContractType, enable_pincode_columns } = rfq.rfqDetails || {};

		return (
			<div className="">
				{
					stops.map((stop, index) => {
						const fromType = `searchFromText-${index}`;
						const toType = `searchToText-1`;

						const fromText = this.state[fromType] || (user.showPinCodeDetails && !this.state.hasOwnProperty(fromType) && stop.location && `${stop.location}, ${stop.pincode}`) || (!this.state.hasOwnProperty(fromType) && (isEmami ? (stop.location && `${stop.location || stop.city}` || '') : stop.location) || '') ||  '';
						const toText = this.state[toType] || (user.showPinCodeDetails && !this.state.hasOwnProperty(toType) && stops[1].location && `${stops[1].location}, ${stops[1].pincode}`) || (!this.state.hasOwnProperty(fromType) && (isEmami ? (stops[1].location && `${stops[1].location || stops[1].city}` || '') : stops[1].location) || '') || '';

						const showFromSugguest = this.state[`show${fromType}Autosuggest`] || false;
						const showToSugguest = this.state[`show${toType}Autosuggest`] || false;

						let sourceList = [];
						if(autoSuggestLocations && autoSuggestLocations.length > 0) {
							sourceList = [...new Map(autoSuggestLocations.map((item) => [item["source"], item])).values()];
						}
						return (
							<Fragment>
								{index !== 1 && <div key={stop.id} className="border-status-bar br-5 pl-10 pr-10 pt-20 pb-20 mb-30 pr">
									{index > 1 && <CloseIcon className="pa t--15 r--15 curP" onClick={this.removeStop.bind(this, index)} />}
									{index === 0 && <div className="header-medium-color fBold fs-20 mb-20">{ftlContractType === 2 ? 'Source' : 'Source To Destination'}</div>}
									{index > 1 && <div className="header-medium-color fBold fs-20 mb-20">Stop {index - 1}</div>}

									{/* {rfqServiceType === 4 && index === 0  && <Checkbox  label="Round Trip" checked = {this.state.isRoundTrip} className="mt-10 mb-10" onCheck={() => {
                                    const { isRoundTrip } = this.state;
                                    this.setState({ isRoundTrip : !isRoundTrip }, () => {
                                        this.props.isRoundTripChange(this.state.isRoundTrip);
                                    });
                                }}/>} */}

									{user.tk11_routecode_validation && isCPLY && index < 2 && this.getRouteCodeElement()}
									{isEmami && this.getClusterDetails()}
									{CARGIL.includes(user.companyId) && ftlContractType == 1 &&
									<>
									<div className="fSemibold fs-18 header-medium-color mb-5 pr">Consignee Type<sup className="danger-color ml-2 pr t-4">*</sup></div>
									<Dropdown
										items={ftlContractTypeList || []}
										selectedItem={this.trip.consigneeType && (ftlContractTypeList || []).find(el =>{return el.id === this.trip.consigneeType})} 
										displayKey="name" 
										name="consigneeType" 
										label="Select..." 
										className="mb-20"
										onSelect={(item) => {
											this.trip.consigneeType = item.id;
											this.trip.consigneeTypeName = item.name
											this.trip.setConsigneeType(item);
											this.props.onChange();
										}}
										hasError={submitted && !(ftlContractTypeList || []).find(el =>{return el.id === this.trip.consigneeType})}
									/>
								</>}
									<div className="flex flex-between mb-30">
										<div className="col-2 mr-20 pr">
											{index !== 0 && <div className="fSemibold fs-18 header-medium-color mb-5">Location<sup className="danger-color ml-2 pr t-4">*</sup></div>}
											{index === 0 && <div className="fSemibold fs-18 header-medium-color mb-5">{`${rfqServiceType === 4 ? 'Container Pickup' : 'From'}`}<sup className="danger-color ml-2 pr t-4">*</sup></div>}
											{
												showCustomLocationInput
													?
													<Fragment>
														<Input
															name={fromType}
															value={fromText}
															onChange={(e) => { this.onChange(e, index) }}
														// onChange={this.handleCustomLocationSearch} 
														/>
														{
															showFromSugguest && fromText && fromText.length > 0 && !isEmami && // searchMatch && searchMatch.length > 0 &&  
															<ClickOutside handleClickOutside={() => this.onhideAutosuggest(`show${fromType}Autosuggest`)}>
																<div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1">
																	{
																		fromText && fromText.length > 0 && (((user.showPinCodeDetails) ? autoSuggestLocations[index !== 0 ? 'destination' : 'source'] : (isCPLY ? sourceList : ((beam || dpl) ? [...new Map(masterRouteCodeDetails.map((item) => [item["source"], item])).values()] : autoSuggestLocations))) || []).filter((item) => {
																			if (!fromText) {
																				return true;
																			}
																			return (user.showPinCodeDetails ? item['pincode'].includes(fromText) : ((isCPLY || beam || dpl) ? (item['source'].toLowerCase().includes(fromText.toLowerCase())) : (item['city'].toLowerCase().includes(fromText.toLowerCase()) || item['state'].toLowerCase().includes(fromText.toLowerCase()))));
																		}).map((item, searchIndex) => {
																			return (
																				<div
																					key={searchIndex}
																					name={item.city}
																					className={"flex flex-middle pl-16 min-ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
																					onClick={() => this.onSelect(fromType, item, index)}
																				>
																					{(user.showPinCodeDetails && item.location) ? <> {item.location} {item.pincode}</> : <>
																					{(isCPLY || beam || dpl) ? <>{`${item.source}${(beam || dpl) ? `, ${item.source_district} ,${item.source_state}` : ''}`}</> :
																					<>{item.city} {item.state} {item.country} {item.pincode}</>}</>}
																				</div>
																			)
																		})
																	}
																</div>
															</ClickOutside>
														}
													</Fragment>
													:
													<Fragment>
														{!this.viewMode &&
															<PlacesAutoComplete
																hasError={submitted && !stop.location && !consigners[index]}
																setLocation={this.setLocation.bind(this, index)}
																value={stop.location || ''}
																// optionList={this.getOptionList(index)}
															/>
														}
													</Fragment>
											}

											{showCustomLocationInput && submitted && !stop.location && <div className={'error-color fs-14 fSemibold op-7 ml-5'}>{'Please Enter the location'}</div>}

											{this.viewMode && <Input value={stop.location || ''} />}
											{enable_pincode_columns &&  index === 0 &&<div className="mt-20">
												<div className="fSemibold fs-18 header-medium-color mb-5">Pickup Pin Code<sup className="danger-color ml-2 pr t-4">*</sup></div>
												<div className="pr">
													{pincodeLoading[index] && <ActionLoader />}
													<Input placeholder="Enter Pickup PIN Code" maxLength={6} value={stop.pincode || ''} readOnly={this.viewMode || pincodeLoading[index]} onChange={this.changePincode.bind(this, index)} onBlur={() => this.validatePincode(index)} hasError={!!this.getPincodeError(index, stop.pincode, 'Please Enter the Pickup PIN Code')} errorMessage={this.getPincodeError(index, stop.pincode, 'Please Enter the Pickup PIN Code')} />
												</div>
											</div>}
										</div>
										{index === 0 && ftlContractType !== 2 && <div className="col-2 pr">
											{index !== 0 && <div className="fSemibold fs-18 header-medium-color mb-5">Location</div>}
											{index === 0 && <div className="fSemibold fs-18 header-medium-color mb-5">{`${rfqServiceType === 4 ? 'Container Drop' : 'To'}`}<sup className="danger-color ml-2 pr t-4">*</sup></div>}

											{ftlContractType === 3 ? <>
												<Dropdown
													items={zoneWiseDetails || []}
													selectedItem={(stops[1] || {}).location && (zoneWiseDetails || []).find(zone=>{return zone.name === stops[1].location})} 
													displayKey="name" 
													name="location" 
													label="Select Zone" 
													onSelect={(option) => this.setLocation(1, {
														location: option.name,
														city: option.name
													})}
													hasError={submitted && !(zoneWiseDetails || []).find(zone=>{return zone.name === (stops[1] || {}).location})}
												/>
											</>
											: <>{
												showCustomLocationInput
													?
													<Fragment>
														<Input
															name={toType}
															value={toText}
															onChange={(e) => { this.onChange(e, 1) }}
														/>
														{
															showToSugguest && toText && toText.length > 0 && !isEmami &&  // searchToMatch && searchToMatch.length > 0 &&
															<ClickOutside handleClickOutside={() => this.onhideAutosuggest(`show${toType}Autosuggest`)}>
																<div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1">
																	{
																		toText && toText.length > 0 && (user.showPinCodeDetails ? autoSuggestLocations.destination : ((beam || dpl) ? masterRouteCodeDetails :autoSuggestLocations)).filter((item) => {
																			if (!toText) {
																				return true;
																			}
																			return (user.showPinCodeDetails ? item['pincode'].includes(toText) : ((isCPLY || beam || dpl) ? (item['destination'].toLowerCase().includes(toText.toLowerCase())) : (item['city'].toLowerCase().includes(toText.toLowerCase()) || item['state'].toLowerCase().includes(toText.toLowerCase()))));
																		}).map((item, searchIndex) => {
																			return (
																				<div
																					key={searchIndex}
																					name={item.city}
																					className={"flex flex-middle pl-16 ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
																					onClick={() => this.onSelect(toType, item, 1)}
																				>
																					{(user.showPinCodeDetails && item.location) ? <> {item.location} {item.pincode}</> : <>{(isCPLY || beam || dpl) ? <>{`${item.destination}${(beam || dpl) ? `, ${item.destination_district} ,${item.destination_state}` : ''}`}</> :
																					<>{item.city} {item.state} {item.country} {item.pincode}</>}</>}
																				</div>
																			)
																		})
																	}
																</div>
															</ClickOutside>
														}
													</Fragment>
													:
													<Fragment>
														{!this.viewMode &&
															<PlacesAutoComplete hasError={submitted && !stops[1].location} setLocation={this.setLocation.bind(this, 1)} value={stops[1].location || ''} />}
														{this.viewMode && rfqServiceType !== 4 && <Input value={stops[1].location || ''} />}
													</Fragment>
											}
											{showCustomLocationInput && submitted && !stops[1].location && <div className={'error-color fs-14 fSemibold op-7 ml-5'}>{'Please Enter the location'}</div>}
												{enable_pincode_columns && <div className="mt-20">
												<div className="fSemibold fs-18 header-medium-color mb-5">Drop Pin Code<sup className="danger-color ml-2 pr t-4">*</sup></div>
												<div className="pr">
													{pincodeLoading[1] && <ActionLoader />}
													<Input placeholder="Enter Drop PIN Code" maxLength={6} value={stops[1].pincode || ''} readOnly={this.viewMode || pincodeLoading[1]} onChange={this.changePincode.bind(this, 1)} onBlur={() => this.validatePincode(1)} hasError={!!this.getPincodeError(1, stops[1].pincode, 'Please Enter the Drop PIN Code')} errorMessage={this.getPincodeError(1, stops[1].pincode, 'Please Enter the Drop PIN Code')} />
												</div>
											</div>}
											</>}
										</div>}
										{index !== 0 && ftlContractType !== 2 && <div className="col-2">
											<div className="fSemibold fs-18 header-medium-color mb-5">Address</div>
											<Input placeholder="Enter Address" value={stop.landmark} onChange={this.changeLandmark.bind(this, index)} />
										</div>}

									</div>
									{ftlContractType !== 2 && <div className="flex flex-between">
										{index !== 0 && <div className="col-2 mr-20">
											<div className="fSemibold fs-18 header-medium-color mb-10">Location</div>
											<div className="flex flex-middle">
												<Checkbox label="Pick" checked={stop.type === 1} className="mr-10" onCheck={this.changeStopType.bind(this, index, 1)} />
												<Checkbox label="Drop" checked={stop.type === 2} className="mr-10" onCheck={this.changeStopType.bind(this, index, 2)} />
												<Checkbox label="Pick & Drop" checked={stop.type === 3} onCheck={this.changeStopType.bind(this, index, 3)} />
											</div>
											{enable_pincode_columns && stop.type && <div className="mt-20">
												<div className="fSemibold fs-18 header-medium-color mb-5">{stop.type === 1 ? 'Pickup Pin Code' : stop.type === 2 ? 'Drop Pin Code' : 'Pickup & Drop Pin Code'}<sup className="danger-color ml-2 pr t-4">*</sup></div>
												<div className="pr">
													{pincodeLoading[index] && <ActionLoader />}
													<Input placeholder={`Enter ${stop.type === 1 ? 'Pickup' : stop.type === 2 ? 'Drop' : 'Pickup & Drop'} PIN Code`} maxLength={6} value={stop.pincode || ''} readOnly={this.viewMode || pincodeLoading[index]} onChange={this.changePincode.bind(this, index)} onBlur={() => this.validatePincode(index)} hasError={!!this.getPincodeError(index, stop.pincode, 'Please Enter the PIN Code')} errorMessage={this.getPincodeError(index, stop.pincode, 'Please Enter the PIN Code')} />
												</div>
											</div>}
										</div>}
										{index !== 0 && <div className="col-2">
											<div className="fSemibold fs-18 header-medium-color mb-5">Additional Price For This Stop</div>
											<Input placeholder="Enter Price" value={stop.additionalPrice} onChange={this.changeAdditionalPrice.bind(this, index)} />
										</div>}
										{index === 0 && ftlContractType !== 3 &&  <div className="col-2 mr-20">
											<div className="fSemibold fs-18 header-medium-color mb-5">Address</div>
											<Input className="mb-30" placeholder="Enter Address" value={stop.landmark} onChange={this.changeLandmark.bind(this, index)} />

											{isMundraSolar && <Fragment>
												<div className="fSemibold fs-18 header-medium-color mb-5">SO</div>
												<Input className="mb-30" placeholder="Enter SO" value={this.trip.so || ''} onChange={this.OnChangeSo} />
											</Fragment>}

											<div className="fSemibold fs-18 header-medium-color mb-5">Remarks</div>
											<Input placeholder="Enter Remarks" className="mb-30" value={stop.remarks} onChange={this.changeRemarks.bind(this, index)} />

											{!isCPLY && (user.tk11_routecode_validation || beam || dpl || isCoromandel()) && (isCoromandel() || (stops[0].location && (stops[1] || {}).location)) && this.getRouteCodeElement(stops)}

											{(rfqServiceType === 4 || isDesmet()) && <Fragment>
												<div className="fSemibold fs-18 header-medium-color mb-5">Consignor<sup className={'danger-color ml-2 pr t-4'}>*</sup></div>
												<Autosuggest
													suggestions={this.getNetWorkDataDetails((isDesmet() ? consignorDetails : networkData), (consigners[index] || {}).consignee_name)}
													onSuggestionsFetchRequested={this.onConsignorSuggestionsFetchRequested}
													// onSuggestionsClearRequested={this.onClearNetworkSuggestion}
													getSuggestionValue={getNetworkSuggestionValue}
													renderSuggestion={renderNetworkSuggestion}
													inputProps={{
														placeholder: "Search",
														value: consigners[index] ? consigners[index].consigner_name : '',
														onChange: (e) => {
															let { consigners } = this.state;
															if (consigners.length === 0) {
																const obj = {
																	consigner_name: e.target.value,
																	consigner_id: ''
																}
																consigners.push(obj);
															} else {
																// if(e.target.value)
																//  {
																consigners[index].consigner_name = e.target.value;
																//  }   
															}
															this.setState({ consigners });
														}
													}
													}
													id="consigner"
													onSuggestionSelected={(event, { suggestion }) => {
														const { consigners } = this.state;
														consigners[index]['consigner_name'] = suggestion.branch_name;
														consigners[index]['consigner_id'] = suggestion.branch_id;
														if(isDesmet()) {
															consigners[index] = {
																['consigner_name']: suggestion.company_name,
																...suggestion
															}
															if (suggestion.address) {
																const stops = [...this.state.stops];
																stops[0].location = suggestion.address;
																this.stops[0].setLocation({ location: suggestion.address, city: suggestion.address });
																this.setState({ consigners, stops });
																this.props.onChange();
																return;
															}
														}
														this.setState({ consigners });
													}
													}
												/>
												{submitted && !consigners[index] && <div className={'error-color fs-14 fSemibold op-7 mt-10 ml-5'}>{'Please Enter The Consignor'}</div>}
											</Fragment>
											}
										</div>
										}

										{index === 0 && ftlContractType !== 3 && <div className="col-2">
											<div className="fSemibold fs-18 header-medium-color mb-5">Address</div>
											<Input className="mb-30" placeholder="Enter Address" value={stops[1].landmark} onChange={this.changeLandmark.bind(this, 1)} />

											{isMundraSolar && <Fragment>
												<div className="fSemibold fs-18 header-medium-color mb-5">PDC</div>
												<Input className="mb-30" placeholder="Enter PDC" value={this.trip.pdc || ''} onChange={this.OnChangePdc} />
											</Fragment>}

											<div className="fSemibold fs-18 header-medium-color mb-5">Remarks</div>
											<Input className="mb-30" placeholder="Enter Remarks" value={stops[1].remarks} onChange={this.changeRemarks.bind(this, 1)} />

											{this.trip.is_existing_contract &&  <>
												<div className="fSemibold fs-18 header-medium-color mb-5">Contract Exist Remarks</div>
												<Input className="mb-5" placeholder="Enter Remarks" value={this.trip.contract_exist_remarks} onChange={this.props.contractExistRemarks} hasError={submitted && this.trip.is_existing_contract && !this.trip.contract_exist_remarks} errorMessage={'Enter the remarks'}/>
											</>}

											{(rfqServiceType === 4 || isDesmet()) && <Fragment>
												<div className="fSemibold fs-18 header-medium-color mb-5">Consignees{isDesmet() && <sup className={'danger-color ml-2 pr t-4'}>*</sup>}</div>
												<Autosuggest
													suggestions={this.getNetWorkDataDetails(networkData, (consignees[index] || {}).consignee_name)}
													onSuggestionsFetchRequested={this.onConsigneeSuggestionsFetchRequested}
													getSuggestionValue={getNetworkSuggestionValue}
													renderSuggestion={renderNetworkSuggestion}
													inputProps={{
														placeholder: "Search",
														value: consignees[index] ? consignees[index].consignee_name : '',
														onChange: (e) => {
															const { consignees } = this.state;
															if (consignees.length === 0) {
																const obj = {
																	consignee_name: e.target.value,
																	consignee_id: ''
																}
																consignees.push(obj);
															} else {
																consignees[index].consignee_name = e.target.value;
															}
															this.setState({ consignees });
														}
													}
													}
													id="Consignees"
													onSuggestionSelected={(event, { suggestion }) => {
														const { consignees } = this.state;
														consignees[index]['consignee_name'] = suggestion.branch_name;
														consignees[index]['consignee_id'] = suggestion.branch_id;
														if(isDesmet()) {
															consignees[index] = {
																['consignee_name']: suggestion.company_name,
																...suggestion
															}
															if (suggestion.address) {
																const stops = [...this.state.stops];
																stops[1].location = suggestion.address;
																this.stops[1].setLocation({ location: suggestion.address, city: suggestion.address });
																this.setState({ consignees, stops });
																this.props.onChange();
																return;
															}
														}
														this.setState({ consignees });
													}
													}
												/>
												{submitted && !consignees[index] && <div className={'error-color fs-14 fSemibold op-7 mt-10 ml-5'}>{'Please Enter the consignee'}</div>}
											</Fragment>}
										</div>}
									</div>}
									{ftlContractType === 3 &&  
										<div className="col-2 mr-20">
											<div className="fSemibold fs-18 header-medium-color mb-5">No. Of Drops Points</div>
											<Input placeholder="Enter Remarks" value={this.trip.noOfDropPoints} onChange={this.changeDropPoints.bind(this, 'noOfDropPoints')} hasError={submitted && !this.trip.noOfDropPoints} errorMessage={'Enter the from km'}/>
										</div>}
									{
										ftlContractType === 2 && 
										<div className="flex flex-between mt-20">
										<div className="col-2 mr-20">
											<div className="fSemibold fs-18 header-medium-color mb-5">From Km</div>
											<Input type="number" placeholder="Eg.. 1" value={fromRange} onChange={this.setFromToRange.bind(this, 'fromRange')} hasError={submitted && !this.trip.fromRange} errorMessage={'Enter the from km'}/>
										</div>
										<div className="col-2 mr-20">
											<div className="fSemibold fs-18 header-medium-color mb-5">To Km</div>
											<Input type="number" placeholder="Eg... 10" value={toRange} onChange={this.setFromToRange.bind(this, 'toRange')} hasError={submitted && !this.trip.toRange} errorMessage={'Enter the to km'}/>
										</div>
										</div>
									}
									{index !== 0 && <div className="flex flex-between mt-20">
										{index !== 0 && <div className="col-2 mr-20">
											<div className="fSemibold fs-18 header-medium-color mb-5">Remarks</div>
											<Input placeholder="Enter Remarks" value={stop.remarks} onChange={this.changeRemarks.bind(this, index)}/>
										</div>}
										<div className="col-2">
											{rfqServiceType === 4 && stop.type && stop.type === 1 && <Fragment>
												<div className="fSemibold fs-18 header-medium-color mb-5">Consignor</div>
												<Autosuggest
													suggestions={networkData || []}
													onSuggestionsFetchRequested={this.onSelectNetworkSuggestion}
													getSuggestionValue={getNetworkSuggestionValue}
													renderSuggestion={renderNetworkSuggestion}
													inputProps={{
														placeholder: "Search",
														value: consigners[index - 1] ? consigners[index - 1].consigner_name : '',
														onChange: (e) => {
															const { consigners } = this.state;
															if (!consigners[index - 1]) {
																const obj = {
																	consigner_name: e.target.value,
																	consigner_id: ''
																}
																consigners.push(obj);
															} else {
																consigners[index - 1].consigner_name = e.target.value
															}
															this.setState({ consigners });
														}
													}
													}
													id="consigner"
													onSuggestionSelected={(event, { suggestion }) => {
														const { consigners } = this.state;
														consigners[index - 1]['consigner_name'] = suggestion.branch_name;
														consigners[index - 1]['consigner_id'] = suggestion.branch_id;
														this.setState({ consigners });
													}
													}
												/>
												{submitted && !consigners[index - 1] && <div className={'error-color fs-14 fSemibold op-7 mt-10 ml-5'}>{'Please Enter The consignor'}</div>}
											</Fragment>}

											{rfqServiceType === 4 && stop.type && stop.type === 2 && <Fragment>
												<div className="fSemibold fs-18 header-medium-color mb-5">Consignees</div>
												<Autosuggest
													suggestions={networkData || []}
													onSuggestionsFetchRequested={this.onSelectNetworkSuggestion}
													getSuggestionValue={getNetworkSuggestionValue}
													renderSuggestion={renderNetworkSuggestion}
													inputProps={{
														placeholder: "Search",
														value: consignees[index - 1] ? consignees[index - 1].consignee_name : '',
														onChange: (e) => {
															const { consignees } = this.state;
															if (!consignees[index - 1]) {
																const obj = {
																	consignee_name: e.target.value,
																	consignee_id: 'dummy'
																}
																if (!consignees[0]) {
																	consignees.push({
																		consignee_name: '',
																		consignee_id: 'dummy'
																	})

																};
																consignees.push(obj);
															} else {
																consignees[index - 1].consignee_name = e.target.value;
															}
															this.setState({ consignees });
														}
													}
													}
													id="Consignees"
													onSuggestionSelected={(event, { suggestion }) => {
														const { consignees } = this.state;
														consignees[index - 1]['consignee_name'] = suggestion.branch_name;
														consignees[index - 1]['consignee_id'] = suggestion.branch_id;
														this.setState({ consignees });
													}
													}
												/>
												{submitted && !consignees[index - 1] && <div className={'error-color fs-14 fSemibold op-7 mt-10 ml-5'}>{'Please Enter The Consignee'}</div>}
											</Fragment>}
										</div>
									</div>}

								</div>}
							</Fragment>
						)
					})
				}
				{![2, 3].includes(ftlContractType) && <div className="flex flex-middle wt-max-content" onClick={this.addStop}>
					<div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5 curP">
						<PlusIcon className="wt-15 ht-15" />
					</div>
					<div className="fSemibold fs-16 fBold header-dark-color curP">{`${rfqServiceType === 4 ? 'Add Cargo Drop' : 'Add Stop'}`}</div>
				</div>}
			</div>
		)
	}
}

export default withRouter(StopDetails);
